import React, {Fragment} from "react";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import {withTranslation} from "react-i18next";
import {
  getTimingsLabelTranslations,
  NSI_RESPONSE_DOWNLOAD_SIZE_KEY,
  TOTAL_KEY
} from "../../constants/getTimingsLabelTranslation";
import {GENERATING_HTML_TIME_KEY, OBSERVATION_COUNT_KEY, SERVER_TIMINGS_KEY} from "../../state/dataset/constants";

const dividerStyle = {margin: "16px 0"};

const getRow = (label, value, isTitle) => (
  <Grid
    container
    key={label}
    justifyContent="space-between"
    spacing={2}
    sx={{
      height: isTitle ? "40px" : undefined
    }}
  >
    <Grid
      item
      sx={[
        isTitle && {
          fontSize: "15px",
          fontWeight: "bold",
          textDecoration: "underline"
        }
      ]}
    >
      {label}
    </Grid>
    {value && (
      <Grid item>
        <b>{value}</b>
      </Grid>
    )}
  </Grid>
);

const DataViewerTimings = ({t, timings}) => {
  const rows = [];

  if (timings) {
    if (timings[GENERATING_HTML_TIME_KEY] !== null && timings[GENERATING_HTML_TIME_KEY] !== undefined) {
      rows.push(getRow(t("timings.observationCount"), timings[OBSERVATION_COUNT_KEY], true));
      rows.push(<Divider sx={dividerStyle} key="divider1" />);
    }

    /** server side **/
    if (timings[SERVER_TIMINGS_KEY]) {
      rows.push(getRow(t("timings.serverTimings"), null, true));

      for (const key in timings[SERVER_TIMINGS_KEY]) {
        if (timings[SERVER_TIMINGS_KEY].hasOwnProperty(key)) {
          if (key !== TOTAL_KEY && key !== NSI_RESPONSE_DOWNLOAD_SIZE_KEY) {
            rows.push(getRow(getTimingsLabelTranslations(t)[key] || key, timings[SERVER_TIMINGS_KEY][key]));
          }
        }
      }
      rows.push(
        getRow(getTimingsLabelTranslations(t)[TOTAL_KEY] || TOTAL_KEY, timings[SERVER_TIMINGS_KEY][TOTAL_KEY], true)
      );
      rows.push(<Divider sx={dividerStyle} key="divider2" />);

      if (timings[SERVER_TIMINGS_KEY][NSI_RESPONSE_DOWNLOAD_SIZE_KEY]) {
        rows.push(
          getRow(
            getTimingsLabelTranslations(t)[NSI_RESPONSE_DOWNLOAD_SIZE_KEY] || NSI_RESPONSE_DOWNLOAD_SIZE_KEY,
            timings[SERVER_TIMINGS_KEY][NSI_RESPONSE_DOWNLOAD_SIZE_KEY],
            true
          )
        );
        rows.push(<Divider sx={dividerStyle} key="divider3" />);
      }
    }

    /** client side **/
    if (timings[GENERATING_HTML_TIME_KEY] !== null && timings[GENERATING_HTML_TIME_KEY] !== undefined) {
      rows.push(getRow(t("timings.clientTimings"), null, true));
      rows.push(getRow(t("timings.generatingHtml"), `${timings[GENERATING_HTML_TIME_KEY]}ms`));
    }
  }

  return <Fragment>{rows}</Fragment>;
};

export default withTranslation()(DataViewerTimings);
